module.exports = __webpack_public_path__ + "static/media/Ease My Trades-Stock Market.5d90299e.png";